export const elementTypeIds = {
  HEADING_1: 'heading1',
  HEADING_2: 'heading2',
  HEADING_3: 'heading3',
  HEADING_4: 'heading4',
  HEADING_5: 'heading5',
  HEADING_6: 'heading6',
  PARAGRAPH: 'paragraph',
  QUOTE: 'blockquote',
  BUTTON: 'button',
  NAVIGATION: 'navigation',
  PHONE_NUMBER: 'headerPhone',
  SITE_NAME: 'siteName',
  FORM_LABEL: 'label',
  FORM_INPUT: 'input',
};

export const fontStyleIdsMap = {
  [elementTypeIds.HEADING_1]: 'heading-1',
  [elementTypeIds.HEADING_2]: 'heading-2',
  [elementTypeIds.HEADING_3]: 'heading-3',
  [elementTypeIds.HEADING_4]: 'heading-4',
  [elementTypeIds.HEADING_5]: 'heading-5',
  [elementTypeIds.HEADING_6]: 'heading-6',
  [elementTypeIds.PARAGRAPH]: 'paragraph',
  [elementTypeIds.QUOTE]: 'quote',
  [elementTypeIds.BUTTON]: 'buttons',
  [elementTypeIds.NAVIGATION]: 'navigations',
  [elementTypeIds.PHONE_NUMBER]: 'phone-number',
  [elementTypeIds.SITE_NAME]: 'site-name',
  [elementTypeIds.FORM_LABEL]: 'label',
  [elementTypeIds.FORM_INPUT]: 'input',
};

export const elementStylesMap = {
  FONT_FAMILY: 'FontFamily',
  FONT_WEIGHT: 'FontWeight',
  FONT_SIZE: 'FontSize',
  LINE_HEIGHT: 'LineHeight',
  TEXT_TRANSFORM: 'TextTransform',
  LETTER_SPACING: 'LetterSpacing',
};

export const optionIdsMap = {
  [elementStylesMap.FONT_FAMILY]: 'font-family',
  [elementStylesMap.FONT_WEIGHT]: 'font-weight',
  [elementStylesMap.FONT_SIZE]: 'font-size',
  [elementStylesMap.LINE_HEIGHT]: 'line-height',
  [elementStylesMap.TEXT_TRANSFORM]: 'capitalization',
  [elementStylesMap.LETTER_SPACING]: 'letter-spacing',
  fontColor: 'font-color',
};

export const fontWeightVariantsMap = {
  100: 'Thin',
  200: 'Extra Light',
  300: 'Light',
  400: 'Regular',
  regular: 'Regular',
  500: 'Medium',
  600: 'Semi Bold',
  700: 'Bold',
  800: 'Extra Bold',
  900: 'Black',
};

export const capitalizationOptions = [
  {
    id: 'none',
    glyph: 'minus',
    value: 'none',
  },
  {
    id: 'uppercase',
    glyph: 'uppercase',
    value: 'uppercase',
  },
  {
    id: 'lowercase',
    glyph: 'lowercase',
    value: 'lowercase',
  },
  {
    id: 'capitalize',
    glyph: 'capitalization',
    value: 'capitalize',
  },
];

export const letterSpacingSettings = {
  min: -1,
  max: 1,
  step: 0.1,
  supportedUnits: ['em'],
  noAutocomplete: true,
};

export const LINE_HEIGHT_AUTO_DIFF_VALUE = 0.0001; // we need to add a small value to prevent matching with default options in line height select for line heights that are equal to "Auto" option value and trigger "Custom" option instead
